import { ItemCategoryInfoList } from "./const";
import { ItemCategory } from "./enum/enum";

const FilteredItems = [
  ItemCategory.HEALTH,
  ItemCategory.BULLET,
  ItemCategory.MAFIA_TOKEN,
  ItemCategory.KEY,
  ItemCategory.BODYGUARD,
  ItemCategory.HELPER_CREDIT,
  ItemCategory.FOUNDER_TABLE_SHARE
];

export const FilteredItemCategoryList = FilteredItems.map((itemCategory) =>
  ItemCategoryInfoList.find((item) => item.id === itemCategory)
).filter((item): item is NonNullable<typeof item> => item !== undefined);
